import React from 'react';
import './style.css';

export default function Header() {
    return (
        <div className='header'>
            <h2>Tweet Saver</h2>
        </div>
    );
}